
import Vue from "vue";
import {Admin} from "@/models/admin";
import {AdminsService} from "@/services/admins-service";
import {Department, getDepartmentName} from "@/utils/department";

export default Vue.extend({
	data() {
		return {
			admins: [] as Admin[],
			items: [] as Admin[],
			departments: [] as Department[],
		};
	},
	props: {
		value: Array as () => Admin[],
	},
	methods: {
		checkAll(){
			this.admins.forEach(adm => {
				this.updateAdmin(adm, true);
			});
			console.log("checked");
		},
		getDepartmentName(dep: Department): string {
			return getDepartmentName(dep);
		},
		/**
		 * Empty items and add admins from selected Department
		 */
		async updateWithDepartement(dep: Department) {
			this.items = [];
			await this.$nextTick();
			let updateAdmin = this.admins.filter(a => a.isInDepartment(dep));
			updateAdmin.forEach(adm => {
				this.updateAdmin(adm, true);
			});
			await this.$nextTick();
		},
		/**
		 * add or remove admin from items and send items to state
		 */
		updateAdmin(admin: Admin, value: boolean) {
			if (value) {
				this.items.push(admin);
			} else {
				this.items.splice(this.items.findIndex(a => a.id == admin.id), 1);
			}
			this.clearDuplicates();
			this.$emit("input", this.items);
		},
		async clearDuplicates() {
			this.items = [...new Set(this.items)];
			await this.$nextTick();
		},
		/**
		 * See if the given admin is checked.
		 */
		isChecked(admin: Admin): boolean {
			if (this.items.findIndex(a => a.id == admin.id) != -1) {
				return true;
			}
			return false;
		},
		adminLabelName(item: Admin): string {
			return item.name;
		},
		getDepartmentsToShow() {
			this.departments.push(...([
				Department.Secretariaat,
				Department.Sales,
				Department.TechnischeDienst,
				Department.DevWfShopOrOnline,
				Department.Programmatie,
				Department.Marketing,
				Department.Servicepakket,
				Department.Overzetting,
				Department.Boekhoudportaal
			]));
		}

	},
	async created() {
		if (this.value) {
			this.items.push(...this.value);
		}
		this.admins = await AdminsService.getAdmins();
		this.getDepartmentsToShow();
	}
});
